export default "__VITE_ASSET__C0rHv1TV__"